import { styled } from 'libs/ui/styled';

export const DialogContent = styled('div')(() => ({
  padding: 32,
}));
